import { ExternalLink } from "lucide-react";

const resources = [
  {
    name: "Ministry of Manpower",
    href: "https://www.mom.gov.sg/",
    desc: "Official regulations, employer responsibilities and helper welfare guidelines.",
  },
  {
    name: "Employer Orientation Programme",
    href: "https://www.eop.com.sg/",
    desc: "Mandatory orientation for first-time employers of foreign domestic workers.",
  },
  {
    name: "Philippine Embassy Singapore",
    href: "https://www.philippine-embassy.org.sg/",
    desc: "Consular services, POLO and support for Filipino nationals in Singapore.",
  },
];

export default function Resources() {
  return (
    <div className="max-w-6xl mx-auto px-6 sm:px-10 py-20 sm:py-28" data-testid="resources-page">
      <div className="overline mb-4">Resources</div>
      <h1 className="font-serif text-5xl sm:text-6xl leading-tight text-[#0A1128] mb-6">A hand-picked <span className="italic text-[#688A4E]">reading list</span>.</h1>
      <p className="text-lg text-gray-600 mb-16 max-w-3xl">Everything a Singapore employer should know — from official regulations to embassy support.</p>

      <div className="border-t border-gray-200">
        {resources.map((r, i) => (
          <a
            key={r.name}
            href={r.href}
            target="_blank"
            rel="noreferrer"
            data-testid={`resource-${i}`}
            className="group grid md:grid-cols-12 gap-6 border-b border-gray-200 py-10 hover:bg-[#F9F9F7] px-4 -mx-4 transition"
          >
            <div className="md:col-span-1 text-xs tracking-[0.28em] text-gray-400">0{i+1}</div>
            <div className="md:col-span-6">
              <h3 className="font-serif text-3xl text-[#0A1128] group-hover:text-[#688A4E] transition flex items-center gap-3">
                {r.name} <ExternalLink className="w-5 h-5"/>
              </h3>
            </div>
            <div className="md:col-span-5 text-gray-600">{r.desc}</div>
          </a>
        ))}
      </div>

      <div className="mt-24 bg-[#E8ECE1] p-10 sm:p-16 grid md:grid-cols-2 gap-8 items-center">
        <div>
          <div className="overline mb-4">Need help interpreting these?</div>
          <h3 className="font-serif text-3xl text-[#0A1128]">Our consultants can walk you through every requirement in plain English.</h3>
        </div>
        <div className="flex md:justify-end">
          <a href="/contact" className="btn-primary" data-testid="resources-contact">Speak to a Consultant</a>
        </div>
      </div>
    </div>
  );
}
